import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Contract, Reason } from 'src/app/core/models';
import { ContractService, ModalService, RegulationService } from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';

@Component({
  selector: 'app-reason-view-modal-v2',
  templateUrl: './reason-view-modal-v2.component.html',
  styleUrls: ['./reason-view-modal-v2.component.sass']
})
export class ReasonViewModalV2Component extends BaseModal implements OnInit {
  isValid: boolean;
  lastState: any;
  public isLoading: boolean;
  public reason: Reason;
  public contract: Contract;
  public regulations = [];
  public showArea = true;
  public reasonForm: FormGroup;
  public initialState: any;

  constructor(
    private formBuilder: FormBuilder,
    public modalService: ModalService,
    public contractService: ContractService,
    public regulationService: RegulationService
  ) {
    super(modalService);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.reason = this.initialState as Reason || new Reason();
    this.contractService.getById(this.reason.contractId).then(contract => {
      this.contract = contract;
    });
    if (this.reason.regulationIds != null) {
      this.reason.regulationIds.forEach(regulationId => {
        this.regulationService.getById(regulationId).then(res => {
          if (!this.regulations.find(r => r.id === res.id)) {
            this.regulations.push({
              id: res.id,
              shortDescription: res.shortDescription || `${res.code} - ${res.description}`,
              description: res.description
            });
          }
        });
      });
    }
    this.createForm();
  }

  onAllSubmited(): Promise<any> {
    throw new Error('Method not implemented.');
  }

  get applicableModules(): string[] {
    return ((this.reason as any).applicableModules || []).map((m: string) => m.toLowerCase());
  }

  get isOnlyTraffic(): boolean {
    const mods = this.applicableModules;
    return mods.includes('traffic') && !mods.includes('violation');
  }

  get showEnquadramento(): boolean {
    return !this.isOnlyTraffic;
  }

  get showTelas(): boolean {
    return !this.isOnlyTraffic;
  }

  getModuleLabel(module: string): string {
    switch (module) {
      case 'violation': return 'Infração';
      case 'traffic': return 'Passagem';
      default: return module;
    }
  }

  createForm() {
    const s = this.reason.screen || [];
    const enableReason = this.reason.enabled == null ? true : this.reason.enabled;
    this.reasonForm = this.formBuilder.group({
      contractId: [this.reason.contractId],
      code: [this.reason.code],
      name: [this.reason.name],
      regulationIds: [this.reason.regulationIds],
      type: [this.reason.type],
      enabled: [enableReason],
      audit: [s.includes('audit')],
      typing: [s.includes('typing')],
      quarantine: [s.includes('quarantine')],
      validate: [s.includes('validate')],
      triage: [s.includes('triage')],
      verifyValid: [s.includes('verifyValid')],
      verifyInvalid: [s.includes('verifyInvalid')],
      exemptPeriod: [s.includes('exemptPeriod')],
      monitoring: [s.includes('monitoring')],
      validateCFTV: [s.includes('validateCFTV')],
      verifyCFTV: [s.includes('verifyCFTV')],
      serialNumberConfig: [s.includes('serialNumberConfig')],
      preProcessConfig: [s.includes('preProcessConfig')]
    });
    this.reasonForm.valueChanges.subscribe(() => {
      this.isValid = this.reasonForm.valid;
    });
  }

  toggleCollapse(show) {
    this.showArea = !show;
  }
}
